export const translation_hu = {
    back: 'Vissza',
    searching: 'Keresés',
    rows: 'Sorok',
    save: 'Ment',
    yes: 'Igen',
    no: 'Nem',
    cancel: 'Mégsem',
    delete: 'Töröl',
    //header
    welcome: 'Üdvözöljük',
    username: 'Felhasználónév / email cím',
    password: 'Jelszó',
    forgotpwd: 'Elfelejtett jelszó',
    login: 'Bejelentkezés',
    logout: 'Kijelentkezés',
    loginerror: 'Hibás felhasználói név vagy jelszó',
    //footer
    mbkegy: 'Magyar Biokémiai Egyesület',
    allrightsreserved: 'Minden jog fenntartva',
    mbkegy_address: '1117 Budapest, Pázmány Péter sétány 1/C.',
    //Biokem
    mbkegy_journal: 'Biokémia folyóirat',
    mbkegy_guide: 'Útmutató szerzőink számára',
    mbkegy_ens: 'Endnote templát irodalomjegyzékhez',
    mbkegy_volume: '{n} évfolyam',
    mbkegy_title_march: 'március',
    mbkegy_title_jun: 'június',
    mbkegy_title_sept: 'szeptember',
    mbkegy_title_dec: 'december',
    mbkegy_title_merged_jubilee: 'Összevont jubileumi szám',
    mbkegy_title_merged_sept_dec: 'Összevont szeptember+december',
    open_in_new_win: 'Megnyitás új ablakban',
    search: 'Keresés',
    reset: 'Töröl',
    results: 'Találatok',
    no_result: 'Nincs találat',
    search_biokem: 'Keresés a lapszámok között...',
    //MemberSeach
    search_member: 'Keresés a tagok között...',
    member_search: 'Tagkeresés',
    name: 'Név',
    institute: 'Intézet',
    address: 'Cím',
    post: 'Beosztás',
    phone: 'Munkahelyi telefon',
    email: 'Munkahelyi e-mail',
    //NewsLetterMyAdmin
    newsletter_myadmin: 'Hírlevelek kezelése',
    newsletter_myadmin_desc: 'Az Egyesület az alábbi témakban küld hírleveleket. Itt feliratkozhat illetve leiratkozhat az egyes témákkal kapcsolatos hírlevelekről.\nEzeket a beállításokat bármikor megváltoztathatja, bármikor feliratkozhat vagy leiratkozhat ezekről a hírlevelekről.',
    newsletter_success_up: 'A hírlevélre sikeresen feliratkozott!',
    newsletter_success_sub: 'A hírlevélről sikeresen leiratkozott!',
    newsletter_admin_error: 'Hiba a feliratkozás adatainak mentése közben!',
    theme: 'Téma',
    last_sent: 'Utoljára küldve',
    subscription: 'Feliratkozás',
    no_data: 'még nem volt küldve',
    //log
    log_data: 'Napló adatok',
    col_user: 'Felhasználó',
    col_todo: 'Művelet',
    col_text: 'Szöveg',
    col_date: 'Dátum',
    //logNewsletter
    log_newsletter_data: 'Hírlevél napló adatok',
    col_send_batch_id: 'Batch',
    col_newsletter_name: 'Hírlevél',
    col_fullname: 'Felhasználó',
    col_email: 'Email',
    col_error: 'Hiba',
    //galerylist
    galery_list: 'Fotó galériák',
    image: 'kép',
    open_galery: 'Megnézem',
    //administration
    membership_management: 'Tagnyilvántartás',
    aggregate_report: 'Összesített kimutatás',
    membership_report: 'Tagonkénti lista',
    year: 'Év',
    member_count: 'Tagok száma',
    all: 'Mind',
    paid: 'Fizetett',
    unpaid: 'Nem fizetett',
    dues: 'Tagdíj összesen',
    registered_sum: 'Rögzítve összesen',
    report_desc: '* Befizetett összeg évenkénti lebontásban a <span style="color:red">rögzítés dátuma</span> szerint.<br />Ekkora összeget fizettek be az adott évben, de előfordulhat, hogy ennek az összegnek egy része nem az adott évi tagdíj-befizetés<br />(Utólagos tagdíjbefizetés: a 2012-ben rögzített 2011-es tagdíj az utlsó előtti oszlopban a 2011-es, az utolsó oszlopban a 2012-es sorban jelenik meg.)',
    //admin edit
    only_members: 'Csak a tagok',
    anew: 'Új',
    edit: 'Szerkeszt',
    back_to_list: 'Vissza a felhasználók listájához',
    new_user: 'Új felhasználó',
    personal_data: 'Személyes adatok',
    workplace_data: 'Munkahelyi adatok',
    membership_data: 'Tagság',
    //user form
    name_prefix_label: 'Név előtag (dr., prof.,)',
    fullname_label: 'Teljes név',
    username_label: 'Felhasználói név',
    change_password: 'Megváltoztatom a jelszót',
    pwd_label: 'Jelszó',
    pwd_re_label: 'Jelszó mégegyszer',

    workspace_label: 'Munkahely',
    workspace_address_label: 'Munkahely címe',
    workspace_post_label: 'Beosztás',
    workspace_phone_label: 'Munkahelyi telefon',
    workspace_email_label: 'Munkahelyi e-mail',
    user_statement_label: 'Nyilatkozat',
    user_statement: "Szakmai adataim (munkahely, munkahely címe, beosztás, munkahelyi telefon, munkahelyi e-mail) az egyesület honlapján nyilvánosságra hozhatóak.",
    membership_stil: 'jelenleg is',
    membership_logout: 'Tagság megszüntetése',
    membership_edit: 'Tagság szerkesztése',

    affiliation_amount: 'Összeg',
    affiliation_exemption: 'Mentesség',
    affiliation_payment: 'Befizetés',
    affiliation_year: 'Év',
    affiliation_cd: 'Rögzítve',
    affiliation_pay: 'Fizet',
    affiliation_saved: 'Befizetés sikeresen elmentve!',
    affiliation_save_error: 'Hiba a befizetés mentése közben!',
    affiliation_delete: 'Befizetés törlése',
    affiliation_deleted: 'A befizetés sikeresen törölve!',
    affiliation_delete_error: 'Hiba a befizetés törlése közben!',
    affiliation_delete_confirm: "Biztosan törölni kívánja ezt a befizetést?",

    tab_user_data: 'Felhasználó',
    tab_membership_data: 'Tagság',
    tab_myuser_data: 'Felhasználói adataim',
    tab_mymembership_data: 'Befizetéseim',

    edit_membership: 'Tagság szerkesztése',
    membership_start: 'Tagság kezdete',
    membership_end: 'Tagság vége',
    membership_comment: 'Megjegyzés',
    membership_exit: 'Kilép',
    membership_saved: 'A tagság adatai elmentve!',
    membership_save_error: 'Hiba a tagság adatainak mentése közben',
    membership_terminated: 'A tag sikeresen kiléptetve!',
    membership_terminate_error: 'Hiba a tag kiléptetése közben!',
    user_saved: 'A felhasználó adatai elmentve!',
    user_save_error: 'Hiba a felhasználó adatainak mentése közben!',
    no_membership_data: 'A felhasználónak nincsen tagsága...',
    add_membership: 'Tagság automatikus felvétele',

    error_user_registration_email_send: 'Hiba az új felhasználó értesítésének kiküldése közben! (A felhasználó adatai sikeresen mentve!)',
    error_change_pwd_email_send: 'Hiba a jelszó változása email kiküldése közben!',
    error_validation_unique_usr: 'Ez a felhasználói név már használatban van! Kérem válasszon más felhasználói nevet!',
    error_validation_fullname: 'A teljes név megadása kötelező!',
    error_validation_usr: 'A felhasználói név megadása kötelező!',
    error_validation_usr_length: 'A felhasználói névnek legalább 5 karakter hosszúnak kell lennie!',
    error_validation_pwd_length: 'A jelszónak legalább 5 karakter hosszúnak kell lennie!',
    error_validation_email: 'Az e-mail címének megadása kötelező!',
    error_validation_institute: "Az intézet megadása kötelező!",

    //mydata
    missing_payment: 'Hiányzó befizetés',
    my_payments_and_profile: 'Befizetéseim, adataim',

    //contentmanagement
    content_management: 'Tartalom szerkesztés',
    col_id: 'Id',
    col_content: 'Content',
    col_expiration: 'Expiration',
    col_feature: 'Feature',
    col_visible: 'Látható',
    show_old: 'Régieket is',
    search_content: 'Keresés a tartalmak között',
    content_delete: 'Tartalom törlése',
    content_delete_confirm: 'Biztosan törli a tartalmat?',
    content_deleted: 'Tartalom törölve!',
    content_delete_error: 'A content nem törölhető, mert tartoznak hozzá contentek!',

    //menumanagement
    feature_access_none: 'Mindenki',
    menu_management: 'Menü szerkesztése',
    col_label: 'Label',
    menu_content: 'Tartalom',
    show_invisible: 'Mutasd mindet',
    search_menu: 'Keresés a menük között',
    menu_delete: 'Menü törlése',
    menu_delete_confirm: 'Biztosan törli a menüt?',
    menu_deleted: 'Menü törölve!',
    menu_delete_error: 'A menü nem törölhető, mert tartoznak hozzá almenuk!',

    //newsletter edit
    newsletter_management: '✉ Hírlevelek',
    col_name: 'Téma',
    col_subject: 'Tárgy',
    col_count: 'Feliratkozók',
    newsletter_delete: 'Hírlevél törlése',
    newsletter_delete_confirm: 'Biztosan törölni szeretné a hírlevelet?',
    newsletter_deleted: 'Hírlevél törölve!',
    newsletter_delete_error: 'Hiba a hírlevél törlése küzben!',
    newsletter_show_invisible: 'Rejtett hírleveleket is',
    newsletter_subscribers: 'Címzettek',
    newsletter_name: 'Hírlevél',
    newsletter_subject: 'Tárgy',
    newsletter_attachments: 'Csatolmány',
    address_list: 'Címzettek listája',
    clear_selection: 'Kiválasztás törlése',
    address_list_name: 'Név',
    address_list_email: 'e-mail',
    newsletter_saved: 'Hírlevél elmentve!',
    newsletter_save_error: 'Hiba a hírlevél mentése küzben!',
    newsletter_new: 'Új hírlevél',
    newsletter_all_member: 'Minden tag',
    newsletter_address_copy_from: 'Címzettek másolása innen: ✉ ',
    newsletter_save: 'Hírlevél mentése',
    newsletter_send_test_mail: 'Teszt email küldése',
    newsletter_send_all_mail: 'Küldés a címzetteknek',
    news_letter_test_email: 'Teszt email küldése',
    news_letter_test_email_details: 'Adja meg az email címet, ahova a teszt email-t küldeni szeretné.',
    news_letter_test_email_label: 'Email cim',
    news_letter_all_email: 'Hírlevelek küldése',
    news_letter_all_email_confirm: 'Biztosan elküldi a hírlevelet a címzetteknek?',
    news_letter_test_email_btn: 'Teszt email küldése',
    news_letter_test_email_sent: 'Teszt email sikeresen elküldve!',
    news_letter_test_email_send_error: 'Hiba a teszt email küldése közben!',
    news_letter_email_sent: 'Email-ek sikeresen elküldve!',
    news_letter_email_send_error: 'Hiba az email-ek küldése közben!',

    //contentmanagement edit
    menu_parent: 'Parent',
    menu_access: 'Access',
    menu_label: 'Label',
    menu_visible: 'Látható',
    menu_file_content: 'File content',
    order_index: 'Sorrend',
    menu_saved: 'Menu elmentve!',
    menu_save_error: 'Hiba a menü mentése kozben!',

    content_saved: 'Content elmentve!',
    content_save_error: 'Hiba a content mentése közben!',
    content_parent: 'Parent',
    content_access: 'Access',
    content_title: 'Title',
    content_header: 'Fejléc',
    content_description: 'Description',
    logical_content: 'Logikai',
    content_expired_time: 'Érvényesség',
    content_missing_description: 'Description megadása kötelezó!',

    //forgot pwd
    forgot_pwd: 'Elfelejtett jelszó',
    forgot_pwd_description: 'Amennyiben elfelejtette jelszavát, kérjük adja meg az emil címét, hogy elküldhessük a jelszó visszaállításához szükséges linket tartalmazó üzenetet email-ben.',
    forgot_pwd_email: 'Email cim',
    forgot_pwd_email_send: 'Email küldése',
    forgot_pwd_sent: 'A levelet elküldtük erre az email cimre: ',
    forgot_pwd_send_error: 'Sajnos nem sikerült erre az email címre az email-t elküldeni: ',
    forgot_pwd_new_pwd: 'Új jelszó',
    forgot_pwd_new_pwd_re: 'Új jelszó mégegyszer',
    forgot_pwd_save_pwd: 'Jelszó mentése',
    forgot_pwd_saved: 'A jelszó sikeresen megváltozott!',
    forgot_pwd_err_missing_token: 'Hiányzó token!',
    forgot_pwd_err_invalid_token: 'Hibás token!',
    forgot_pwd_err_used_token: 'Ezt a linket már korábban használták jelszó módosításra!',
    forgot_pwd_err_invalid_email: 'Hibás email cim!',
    forgot_pwd_err_used_email: 'Ez az email cim több felhasználóhoz tartozik!',
    forgot_pwd_err_missing_email: 'Ön vagy nem adta meg az email címét vagy nem ezt az email címet adta meg!',
    forgot_pwd_err_mismatch: 'A jelszó és a megerősítés nem egyezik!',

    //junior registration
    junior_registration: 'Regisztráció a Junior Szekcióba',
    junior_registrate: 'Regisztrálok',
    error_registration_email_send: 'Hibás email cím!',
    junior_reg_verification_email_sent: 'Megerősítő email küldve!',
    junior_reg_verification: 'Regisztráció megerősítése',
    junior_reg_verification_inprogress: 'Regisztráció megerősítése folyamatban...',
    junior_reg_verification_done: 'Regisztráció megerősítése kész!',
    verify_error_missing_token: 'Hiányzó token!',
    verify_error_invalid_token: 'Érvénztelen token!',
    verify_error_used_token: 'Használt token!',

    //junior mydata
    junior_mydata: 'Junior - adataim',
    junior_delete_myprofile: 'Regisztráció törlése',
    junior_delete_myprofile_confirm: 'Biztos törölni szeretnéd a regisztrációdat?',
    junior_statement: 'Adataim megadásával hozzájárulok ahhoz, hogy a Magyar Biokémia Egyesület (MBKE) az általam megadott e-mail címre hírleveleket küldjön. Tudomásul veszem, hogy a hozzájárulásom önkéntes, és bármikor visszavonhatom azt a hírlevelekben található leiratkozási lehetőség használatával, vagy törölhetem a regisztrációmat.',
    junior_mydata_saved: 'Adatok elmentve!',
    junior_mydata_save_error: 'Hiba az adatok mentése közben!',
    junior_mydata_deleted: 'Regisztráció törölve!',
    junior_mydata_delete_error: 'Hiba a regisztráció törlése közben!',
    
    //junior management
    junior_management: 'Junior lista',
    verified: 'Verified',
    only_verified: 'Csak akik megerősítették',
    
    //access check
    access_error_login: 'Az oldal megtekintéséhez jelentkezzen be!',
    access_error_access: 'Az oldal megtekintéséhez nincs jogosultsága!'
};
